const routes = [
    // 外教机构管理路由
    {
      path: "/foreignInst",
      name: "foreignInst",
      meta: {
        title: "机构管理",
        volcengine: true
      },
      component: () => import("@/pages/lsForeign/foreignInst/index.vue")
    },
  ];
  export default routes;